import S3Image from './S3Image';

export default S3Image;
